// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GridItemProps } from "@insite/mobius/GridItem";
import { dealerInformationStyles } from "@pace/Overrides/Widgets/DealerDetails/DealerInformation";
import IconArrowLeft from "@pace/XDL/Icons/IconArrowLeft";
import IconEmail from "@pace/XDL/Icons/IconEmail";
import IconLocations from "@pace/XDL/Icons/IconLocations";
import IconPhone from "@pace/XDL/Icons/IconPhone";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { css } from "styled-components";

const gridItem: GridItemProps = {
    width: 12,
    css: css`
        display: flex;
        flex-direction: column;
        padding-left: 33px;
    `,
};

dealerInformationStyles.selectedDealerDisplayBackToResultsLink = {
    icon: {
        iconProps: {
            src: IconArrowLeft,
            size: 15,
        },
        position: "left",
    },
};

dealerInformationStyles.addressInfoIcon = {
    src: IconLocations,
    color: "secondary",
    size: 18,
};

dealerInformationStyles.phoneLink = {
    icon: {
        iconProps: {
            src: IconPhone,
            size: 18,
        },
        position: "left",
    },
};

dealerInformationStyles.hoursTitle = {
    color: "primary",
    weight: fontConfig.weight.bold,
};

dealerInformationStyles.nameGridItem = gridItem;
dealerInformationStyles.htmlContentGridItem = gridItem;
dealerInformationStyles.googleMapsDirectionLinkGridItem = gridItem;
dealerInformationStyles.visitWebsiteLinkGridItem = gridItem;
dealerInformationStyles.hoursGridItem = gridItem;
dealerInformationStyles.emailGridItem = {
    width: 12,
};
dealerInformationStyles.emailLink = {
    icon: {
        iconProps: {
            src: IconEmail,
            size: 18,
        },
        position: "left",
    },
};
dealerInformationStyles.branchManagerGridItem = gridItem;
dealerInformationStyles.branchManagerLabel = {
    color: "primary",
    weight: fontConfig.weight.bold,
};
dealerInformationStyles.bottomContentGridItem = gridItem;